<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__financial_principles_iii')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__score')}}</th>
                <th>{{$t('medium_grant_ev.diligence__policies_table')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.policy === row.value}" v-for="(row, index) in tablePolicies" :key="index">
                <td>
                  <radio name="model.policy"
                         :value="row.value"
                         v-model="EvaluationForm.model.policy"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="4" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.policy}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_policies" :comments="EvaluationForm.model.comments_policies"></comment-box>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__debt')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__score')}}</th>
                <th>{{$t('medium_grant_ev.diligence__debt_table')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.debt === row.value}" v-for="(row, index) in tableDebt" :key="index">
                <td>
                  <radio name="model.debt"
                         :value="row.value"
                         v-model="EvaluationForm.model.debt"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="4" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.debt}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_debt" :comments="EvaluationForm.model.comments_debt"></comment-box>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__insurance')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__score')}}</th>
                <th>{{$t('medium_grant_ev.diligence__insurance_table')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.insurance === row.value}" v-for="(row, index) in tableInsurance" :key="index">
                <td>
                  <radio name="model.insurance"
                         :value="row.value"
                         v-model="EvaluationForm.model.insurance"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="4" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.insurance}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_insurance" :comments="EvaluationForm.model.comments_insurance"></comment-box>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__bank_accounts')}}</h5>

            <div class="row">
              <div class="col-lg-10"></div>
              <div class="col-lg-2 vertical-border">
                <div class="row">
                  <div class="col-lg-6">
                    {{$t('medium_grant_ev.general__yes')}}
                  </div>
                  <div class="col-lg-6">
                    {{$t('medium_grant_ev.general__no')}}
                  </div>
                </div>
              </div>
              <div class="col-lg-2"></div>
            </div>
            <div class="row mt-3">
              <div class="col-lg-10">
                <h5 class="card-title font-weight-bold">{{$t('medium_grant_ev.diligence__bank_accounts_i')}}</h5>
              </div>
              <div class="col-lg-2 vertical-border">
                <div class="row">
                  <div class="col-lg-6">
                    <radio name="model.have_bank_accounts"
                           value="true"
                           v-model="EvaluationForm.model.have_bank_accounts"
                    >
                    </radio>
                  </div>
                  <div class="col-lg-6">
                    <radio name="model.have_bank_accounts"
                           value="false"
                           v-model="EvaluationForm.model.have_bank_accounts"
                    >
                    </radio>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 mt-4">
                <div class="alert alert-danger">{{$t('medium_grant_ev.diligence__bank_accounts_i_alert')}}</div>
                <p class="font-weight-bold">{{$t('medium_grant_ev.diligence__bank_accounts_i_note')}}</p>
                <div>
                  <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_bank_account" :comments="EvaluationForm.model.comments_bank_account"></comment-box>
                </div>
              </div>
            </div>


            <h5 class="card-title font-weight-bold  mt-5 mb-0">{{$t('medium_grant_ev.diligence__bank_accounts_ii')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__score')}}</th>
                <th>{{$t('medium_grant_ev.diligence__payment_signature_table')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.payment_signature === row.value}" v-for="(row, index) in tableSignature" :key="index">
                <td>
                  <radio name="model.payment_signature"
                         :value="row.value"
                         v-model="EvaluationForm.model.payment_signature"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="4" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.payment_signature}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_payment_signature" :comments="EvaluationForm.model.comments_payment_signature"></comment-box>
            </div>
          </div>
        </div>

      </div>
      <div class="col-lg-3">
        <info-right></info-right>
      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      InfoRight,
      CommentBox
    },
    data() {
      return {
        EvaluationForm,
        tablePolicies: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__table_financial_iii_0')},
          {'value': 2, 'text': this.$i18n.t('medium_grant_ev.diligence__table_financial_iii_2')},
          {'value': 4, 'text': this.$i18n.t('medium_grant_ev.diligence__table_financial_iii_4')},
        ],
        tableDebt: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__table_debt_0')},
          {'value': 2, 'text': this.$i18n.t('medium_grant_ev.diligence__table_debt_2')},
          {'value': 4, 'text': this.$i18n.t('medium_grant_ev.diligence__table_debt_4')},
        ],
        tableInsurance: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__table_insurance_0')},
          {'value': 2, 'text': this.$i18n.t('medium_grant_ev.diligence__table_insurance_2')},
          {'value': 4, 'text': this.$i18n.t('medium_grant_ev.diligence__table_insurance_4')},
        ],
        tableSignature: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__table_signature_0')},
          {'value': 2, 'text': this.$i18n.t('medium_grant_ev.diligence__table_signature_2')},
          {'value': 4, 'text': this.$i18n.t('medium_grant_ev.diligence__table_signature_4')},
        ]
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
    }
  }
</script>